var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1201 1501.25",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Compound Path",
    d: "M1076,918.28,798.52,479.09V269.17A73.58,73.58,0,0,0,796.59,122H404.41a73.58,73.58,0,0,0-1.93,147.14V479.09L125,918.28c-48.23,76.34,6.63,175.89,96.93,175.89H979.05C1069.36,1094.17,1124.22,994.62,1076,918.28ZM373,195.61a31.47,31.47,0,0,1,31.43-31.43H796.59a31.43,31.43,0,0,1,0,62.86H404.41A31.47,31.47,0,0,1,373,195.61Zm40.6,743.95a25.21,25.21,0,1,1,25.22-25.21A25.21,25.21,0,0,1,413.58,939.56Zm78.86,52.08a14.42,14.42,0,1,1,14.42-14.42A14.42,14.42,0,0,1,492.44,991.64ZM497,862a45.71,45.71,0,1,1,45.72-45.71A45.71,45.71,0,0,1,497,862ZM600.5,687.29c-187.44-38.1-269.68,0-269.68,0L453.1,493.74v-216H747.89v51.56H683.6a18.75,18.75,0,0,0,0,37.5h64.29v43.94H683.6a18.75,18.75,0,1,0,0,37.5h64.29v45.47L870.17,687.29S787.93,725.39,600.5,687.29Z",
    fill: "#3082CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.8c03a7635b1a3a719aa11bac330811f6.svg";
export { ForwardRef as ReactComponent };